import { type TableHeaderRow } from '@shared/table-generator';

interface ItemAnalysisYearlyTableHeaderProps {
  title?: string[];
}

export function ItemAnalysisYearlyTableHeader(
  props: Readonly<ItemAnalysisYearlyTableHeaderProps>,
): TableHeaderRow[] {
  return [
    {
      children: [
        {
          id: 'no',
          children: 'No.',
          align: 'center',
          rowSpan: 2,
          width: 64,
        },
        {
          id: 'questionId',
          children: 'QID',
          align: 'center',
          rowSpan: 2,
          width: 200,
        },
        {
          id: 'firstPublish',
          children: 'First Pub.',
          rowSpan: 2,
          width: 110,
        },
        {
          id: 'lastPublish',
          children: 'Last Pub.',
          rowSpan: 2,
          width: 110,
        },
        {
          id: 'type',
          children: 'Type',
          rowSpan: 2,
          width: 100,
        },
        {
          id: 'status',
          children: 'Status',
          rowSpan: 2,
          width: 100,
        },
        {
          id: 'pInitial',
          children: 'P Initial',
          align: 'center',
          rowSpan: 2,
          width: 100,
        },
        {
          id: 'pUsed',
          children: 'P Used',
          align: 'center',
          rowSpan: 2,
          width: 100,
        },
        {
          id: 'pUsed',
          children: `B-Index\n(Initial)`,
          align: 'center',
          rowSpan: 2,
          width: 100,
        },
        ...(props.title ?? []).map((title, i) => ({
          id: `yearlyData${i}`,
          children: title,
          align: 'center' as const,
          colSpan: 3,
          width: 324,
        })),
        ...((props.title ?? []).length > 0
          ? [
              {
                id: 'summary',
                children: 'ข้อมูลสะสมล่าสุด',
                align: 'center' as const,
                colSpan: 3,
              },
            ]
          : []),
      ],
    },
    {
      children: [
        ...(props.title ?? []).flatMap((_, i) => [
          {
            id: `yearlyData${i}_examinees`,
            children: 'จำนวนผู้ใช้งานข้อสอบ',
            align: 'center' as const,
            width: 124,
          },
          {
            id: `yearlyData${i}_pCal`,
            children: 'P Cal',
            align: 'center' as const,
            width: 100,
          },
          {
            id: `yearlyData${i}_bIndex`,
            children: 'B-Index',
            align: 'center' as const,
            width: 100,
          },
        ]),
        ...((props.title ?? []).length > 0
          ? [
              {
                id: 'summary_examinees',
                children: `จำนวนผู้ใช้งาน\n(สะสม)`,
                align: 'center' as const,
                width: 124,
              },
              {
                id: 'summary_pCal',
                children: `P Cal\n(สะสม)`,
                align: 'center' as const,
                width: 100,
              },
              {
                id: 'summary_bIndex',
                children: `B-Index\n(สะสม)`,
                align: 'center' as const,
                width: 100,
              },
            ]
          : []),
      ],
    },
  ];
}
